module.exports = __webpack_public_path__ + "static/media/placeholder_de.d1eca425.jpg";